import { render } from "./SuggestModal.vue?vue&type=template&id=4906e296&scoped=true&ts=true"
import script from "./SuggestModal.vue?vue&type=script&lang=ts"
export * from "./SuggestModal.vue?vue&type=script&lang=ts"

import "./SuggestModal.vue?vue&type=style&index=0&id=4906e296&scoped=true&lang=css"

import exportComponent from "/home/runner/work/angelleague-front/angelleague-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4906e296"]])

export default __exports__